<template>
  <b-modal
    @ok="handleOk"
    cancelTitle="Abbrechen"
    okTitle="OK"
    @cancel="handleCancel"
    :id="modalId"
    :title="
      'Kommentar bearbeiten - ' +
        (allocation ? allocation.Ordinal : '') +
        ' ' +
        (allocation ? allocation.DisplayName : '')
    "
    size="lg"
    @show="loadComment"
  >
    <b-overlay :show="isLoading" style="height: 345px">
      <div class="row mb-2">
        <div class="col">
          <label class="text-muted d-block mb-1">
            <small>Quelle ({{ sourceDesc }})</small>
          </label>
          <div class="bg-light p-1">{{ source ? source.Ordinal : '' }} {{ source ? source.DisplayName : '' }}</div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Zugewiesener Betrag</small></label>
          <div class="bg-light p-1">
            {{
              $utils.formatCurrency(
                allocation && allocation.Amount ? allocation.Amount : source ? source.Amount : 0,
                settingsStore
              )
            }}
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label class="text-muted d-block mb-1"><small>VE Ziel</small></label>
          <div class="bg-light p-1">
            {{ allocation ? allocation.Ordinal : '' }}
            {{ allocation ? allocation.DisplayName : '' }}
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Kommentar</small></label>
          <b-form-textarea
            autofocus
            id="textarea"
            v-model="comment"
            placeholder="Kommentar eingeben..."
            rows="4"
            max-rows="4"
            no-auto-shrink
            maxlength="200"
            :disabled="!$root.$user.isPlaner && !$root.$user.isAdmin"
          ></b-form-textarea>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import allocationsService from '@/service/AllocationsService';
import settingsStore from '@/store/Settings';
export default {
  data() {
    return {
      isLoading: true,
      comment: '',
      settingsStore
    };
  },
  props: {
    allocation: {
      type: Object
    },
    source: {
      type: Object
    },
    modalId: {
      type: String
    }
  },
  emits: ['ok'],
  methods: {
    loadComment() {
      allocationsService
        .getComment(
          this.allocation.Source ? this.allocation.Source : this.source.Source,
          this.allocation.RefDbId ? this.allocation.RefDbId : this.source.RefDbId
        )
        .then(response => (this.comment = response.Comment))
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error.text);
          else this.$showError(this, err.toString());
        })
        .finally(() => (this.isLoading = false));
    },
    handleOk() {
      this.isLoading = true;
      allocationsService
        .updateComment(
          this.allocation.Source ? this.allocation.Source : this.source.Source,
          this.allocation.RefDbId ? this.allocation.RefDbId : this.source.RefDbId,
          this.comment
        )
        .catch(err => {
          console.log(err);
          console.log(err.response);
          if (err.response) this.$showError(this, err.response.data);
          else this.$showError(this, err.toString());
        })
        .finally(() => (this.isLoading = false));
    },
    handleCancel() {}
  },
  computed: {
    sourceDesc() {
      if (this.allocation && this.allocation.Source) {
        return this.allocation.Source.toUpperCase();
      } else if (this.source && this.source.Source) {
        return this.source.Source.toUpperCase();
      } else return '';
    }
  }
};
</script>

<style></style>
